module.exports = __webpack_public_path__ + "static/media/sunny.3a09b5e6.jpg";